module.exports = __webpack_public_path__ + "img/Parlament_Wien_350x350.jpg";